import { render, staticRenderFns } from "./DeactivateAccountModal.vue?vue&type=template&id=08cc07c4&scoped=true&"
import script from "./DeactivateAccountModal.vue?vue&type=script&lang=js&"
export * from "./DeactivateAccountModal.vue?vue&type=script&lang=js&"
import style0 from "./DeactivateAccountModal.vue?vue&type=style&index=0&id=08cc07c4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08cc07c4",
  null
  
)

export default component.exports